import React from "react";
import "../css/dashboard.css";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";


import CasadaSwitchMobile from "../component/CasadaSwitchMobile";

export default function RoomLayoutContentMobile() {

  // useEffect(() => {
  //   if (currentUser?.email) {
  //     recordMetrics(
  //       "Tutorials",
  //       "pageLoadMobile",
  //       currentUser.email,
  //       "read",
  //       "bodhi"
  //     );
  //   }
  // }, [currentUser.email]);

  return (
    <div className="right-container-mobile">
      <TopTitleBannerMobile title={"Rooms layout"} />
      <CasadaSwitchMobile />
    </div>
  );
}
